var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"slidingContainer",staticClass:"sliding-buttons",style:({ top: _vm.position + 'px' })},[_c('p',{staticClass:"history",on:{"click":function($event){$event.stopPropagation();return _vm.handleToHistory.apply(null, arguments)}}},[_vm._v("历史记录")])])
}
var staticRenderFns = []

export { render, staticRenderFns }